import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Container } from '@mantine/core';
import {
  IconBuildingHospital,
  IconClipboard,
  IconStethoscope,
  IconTestPipe,
  IconAlertCircle,
  IconBook,
  IconCurrencyDollar,
  IconHistory,
  IconClipboardList,
  IconPill,
  IconBell,
  IconToggleLeft,
  IconLink,
  IconUsersGroup,
  IconClipboardHeart,
  IconDeviceMobileCheck,
} from '@tabler/icons-react';
import classes from '../../global/style/Classes.module.less';

import Shell from '../../global/component/organism/Shell/Shell';
import { ITabsProps } from '../../global/component/organism/SideBar/SideBar';
import { useTranslation } from 'react-i18next';

const AdminDashboardShell: React.FC = () => {
  const location = useLocation();

  const { t } = useTranslation();

  const adminTabs: ITabsProps[] = useMemo(
    () => [
      {
        ids: ['hcp'],
        icon: IconStethoscope,
        title: t('navbar.hcp'),
      },
      {
        ids: ['hcf'],
        icon: IconBuildingHospital,
        title: t('navbar.hcf'),
      },
      {
        ids: ['survey'],
        icon: IconClipboard,
        title: t('navbar.survey'),
      },
      {
        ids: ['journal'],
        icon: IconBook,
        title: t('navbar.journals'),
      },
      {
        ids: ['testKit'],
        icon: IconTestPipe,
        title: t('navbar.testKit'),
      },
      {
        ids: ['conversion-versions'],
        icon: IconHistory,
        title: t('navbar.opioidConversionVersions'),
      },
      {
        ids: ['dosage-forms'],
        icon: IconPill,
        title: t('navbar.drugDosages'),
      },
      {
        ids: ['billing-management'],
        icon: IconCurrencyDollar,
        title: 'Billing Management',
      },
      {
        ids: ['alert-rules'],
        icon: IconBell,
        title: t('navbar.alertRules'),
      },
      {
        ids: ['emailProblems'],
        icon: IconAlertCircle,
        title: t('navbar.emailProblems'),
      },
      {
        ids: ['feature-management'],
        icon: IconToggleLeft,
        title: t('navbar.featureManagement'),
      },
      {
        ids: ['therapeutic-indication-resources'],
        icon: IconLink,
        title: t('navbar.therapeuticIndicationResources'),
      },
      {
        ids: ['audit-logs'],
        icon: IconClipboardList,
        title: t('navbar.auditLogs'),
      },
      {
        ids: ['scenarios'],
        icon: IconUsersGroup,
        title: t('navbar.scenarios'),
      },
      {
        ids: ['care-plans'],
        icon: IconClipboardHeart,
        title: t('navbar.carePlans'),
      },
      {
        ids: ['switchover'],
        icon: IconDeviceMobileCheck,
        title: t('navbar.switchover'),
      },
    ],
    [t],
  );
  const isSurvey = useMemo(() => {
    return /\/survey\/\d+/.test(location.pathname);
  }, [location]);
  const isScenarioForm = useMemo(() => {
    return /\/scenarios\/\d+/.test(location.pathname);
  }, [location]);

  return (
    <Shell tabs={adminTabs} route="adminDashboard">
      <Container
        style={{ overflow: isSurvey ? 'hidden' : 'auto' }}
        size={isScenarioForm ? '100%' : 'xl'}
        fluid={isScenarioForm}
        className={classes.shellContainer}
      >
        <Outlet />
      </Container>
    </Shell>
  );
};

export default AdminDashboardShell;
